import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import en from '../en.json';
import ja from "./app.ja.json";
import zh from "./app.zh-tw.json";
import en from "./app.en.json";
import vi from "./app.vi.json";
import { localLang } from "../Const/LangList";
const resources = {
    ja: {
        translation: ja,
    },
    en: {
        translation: en,
    },
    vi: {
        translation: vi,
    },
    "zh-TW": {
        translation: zh,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: localLang,
    // debug: true,
    fallbackLng: { default: ["en"] },
    interpolation: {
        escapeValue: false,
    },
    react: {
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    },
});

export default i18n;
